// Shared vocabulary for page-header actions. Business eligibility stays on pages.
const action = (icon, group, priority, labels, secondary = false) => ({
    icon, group, priority, labels, secondary,
    color: group === 'danger' || icon === 'mdi-file-pdf-box' ? 'error' : 'primary',
});
const create = (fr, en) => action('mdi-plus', 'workflow', 100, [fr, en]);
const csv = (direction, fr, en) => ({ ...action(
    direction === 'export' ? 'mdi-file-export-outline' : 'mdi-file-import-outline',
    'data', direction === 'export' ? 20 : 15, [fr, en],
), color: 'success' });
export const TITLE_ACTION_DEFINITIONS = {
    create: create(null, null),
    "create-bundle": create("Créer une fiche technique", "Create a technical sheet"),
    "add-operator": create("Ajouter un opérateur", "Add an operator"),
    "create-establishment": create("Créer un établissement", "Create an establishment"),
    "create-allocation": create("Créer une allocation", "Create an allocation"),
    "create-prospect": create("Créer un prospect", "Create a prospect"),
    "add-indicator": create("Ajouter un indicateur", "Add an indicator"),
    "add-pos-sync": create("Ajouter une connexion de caisse", "Add a POS connection"),
    "create-movement": create("Créer un mouvement", "Create a movement"),
    "create-billing-account": create("Créer un compte de facturation", "Create a billing account"),
    "create-product-type": create("Créer un type de produit", "Create a product type"),
    "create-campaign": create("Créer une campagne", "Create a campaign"),
    "schedule-production": create("Programmer une production", "Schedule production"),
    "create-warehouse": create("Créer un entrepôt", "Create a warehouse"),
    "create-group": create("Créer un groupe", "Create a group"),
    "create-user": create("Créer un utilisateur", "Create a user"),
    'create-order': create('Créer une commande', 'Create an order'),
    'create-invoice': create('Créer une facture', 'Create an invoice'),
    'create-product': create('Créer un produit', 'Create a product'),
    'create-catalog': create('Créer un catalogue', 'Create a catalog'),
    'create-project': create('Créer un projet', 'Create a project'),
    'create-task': create('Créer une tâche', 'Create a task'),
    'create-event': create('Créer un événement', 'Create an event'),
    'create-inventory': create('Créer un inventaire', 'Create an inventory'),
    'create-shipment': create('Planifier une expédition', 'Schedule a shipment'),
    'create-receipt': create('Planifier une réception', 'Schedule a receipt'),
    'create-invoice-line': create('Ajouter une ligne de facture', 'Add an invoice line'),
    'bill-products': create('Facturer des produits', 'Bill products'),
    'create-manual-line': create('Ajouter une ligne libre', 'Add a custom line'),
    'create-subscription': create('Créer un abonnement', 'Create a subscription'),
    'create-address': create('Ajouter une adresse de livraison', 'Add a delivery address'),
    'add-customer': create('Ajouter un client', 'Add a customer'),
    'add-provider': create('Ajouter un fournisseur', 'Add a provider'),
    edit: action('mdi-pencil-outline', 'workflow', 60, ['Modifier', 'Edit']),
    'edit-products': action('mdi-pencil-outline', 'workflow', 55, ['Modifier les produits', 'Edit products']),
    save: action('mdi-content-save-outline', 'workflow', 120, ['Enregistrer', 'Save']),
    configure: action('mdi-cog-outline', 'administration', 50),
    complete: action('mdi-check-circle-outline', 'workflow', 90),
    bill: action('mdi-receipt-text-plus-outline', 'workflow', 80),
    paid: action('mdi-cash-check', 'workflow', 85),
    reopen: action('mdi-lock-open-outline', 'workflow', 90),
    send: action('mdi-email-outline', 'documents', 70),
    'send-test': action('mdi-email-check-outline', 'documents', 10, null, true),
    invite: action('mdi-email-plus-outline', 'workflow', 100),
    download: action('mdi-file-pdf-box', 'documents', 40),
    print: action('mdi-printer-outline', 'documents', 30),
    record: action('mdi-plus', 'workflow', 100),
    'import-statement': action('mdi-file-import-outline', 'data', 100),
    'export-csv': csv('export', 'Exporter en CSV', 'Export as CSV'),
    'import-csv': csv('import', 'Importer en CSV', 'Import from CSV'),
    'export-orders-csv': csv('export', 'Exporter les commandes en CSV', 'Export orders as CSV'),
    'export-order-lines-csv': csv('export', 'Exporter les lignes de commande en CSV', 'Export order lines as CSV'),
    'export-invoices-csv': csv('export', 'Exporter les factures en CSV', 'Export invoices as CSV'),
    'export-invoice-lines-csv': csv('export', 'Exporter les lignes de facture en CSV', 'Export invoice lines as CSV'),
    'export-products-csv': csv('export', 'Exporter les produits en CSV', 'Export products as CSV'),
    'import-products-csv': csv('import', 'Importer les produits en CSV', 'Import products from CSV'),
    'export-providers-csv': csv('export', 'Exporter les fournisseurs en CSV', 'Export suppliers as CSV'),
    'import-providers-csv': csv('import', 'Importer les fournisseurs en CSV', 'Import suppliers from CSV'),
    'export-customers-csv': csv('export', 'Exporter les clients en CSV', 'Export customers as CSV'),
    'import-customers-csv': csv('import', 'Importer les clients en CSV', 'Import customers from CSV'),
    'export-stock-csv': csv('export', 'Exporter les stocks en CSV', 'Export stock as CSV'),
    'export-shipments-csv': csv('export', 'Exporter les expéditions en CSV', 'Export shipments as CSV'),
    'export-shipment-lines-csv': csv('export', 'Exporter le contenu des expéditions en CSV', 'Export shipment items as CSV'),
    'export-receipts-csv': csv('export', 'Exporter les réceptions en CSV', 'Export receipts as CSV'),
    'export-receipt-lines-csv': csv('export', 'Exporter le contenu des réceptions en CSV', 'Export receipt items as CSV'),
    'stock-import': { ...action('mdi-file-import-outline', 'data', 15), color: 'success' },
    duplicate: action('mdi-content-copy', 'administration', 0, ['Dupliquer', 'Duplicate'], true),
    assign: action('mdi-account-plus-outline', 'administration', 0, null, true),
    unassign: action('mdi-account-minus-outline', 'administration', 0, null, true),
    recalculate: action('mdi-calculator-variant-outline', 'administration', 0, null, true),
    reset: action('mdi-restore', 'administration', 0, ['Réinitialiser', 'Reset'], true),
    'set-default': action('mdi-star-outline', 'administration', 0, ['Définir par défaut', 'Set as default'], true),
    archive: action('mdi-archive-outline', 'danger', 0, ['Archiver', 'Archive'], true),
    unarchive: action('mdi-archive-arrow-up-outline', 'administration', 80, ['Désarchiver', 'Unarchive']),
    delete: action('mdi-delete-outline', 'danger', 0, ['Supprimer', 'Delete'], true),
    cancel: action('mdi-close-circle-outline', 'danger', 0, null, true),
    disconnect: action('mdi-link-off', 'danger', 0, null, true),
    retry: action('mdi-refresh', 'administration', 20),
    history: action('mdi-history', 'administration', 0, null, true),
    account: action('mdi-account-cash-outline', 'administration', 10),
    credit: action('mdi-receipt-text-minus-outline', 'workflow', 30),
    replace: action('mdi-file-replace-outline', 'documents', 0, null, true),
    absorb: action('mdi-account-convert-outline', 'administration', 0, null, true),
    enable: action('mdi-play-circle-outline', 'workflow', 90),
    disable: action('mdi-pause-circle-outline', 'administration', 0, null, true),
    'show-graph': action('mdi-chart-line', 'administration', 10),
    'adjust-stock': action('mdi-swap-vertical', 'workflow', 60),
    'transfer-stock': action('mdi-warehouse', 'workflow', 50),
    inventory: action('mdi-clipboard-check-outline', 'workflow', 70),
    'push-catalog': action('mdi-cloud-upload-outline', 'data', 20),
    'import-sales': action('mdi-cloud-download-outline', 'data', 100),
    cart: action('mdi-cart-plus', 'workflow', 70),
    hide: action('mdi-eye-off-outline', 'administration', 0, null, true),
    show: action('mdi-eye-outline', 'administration', 0, null, true),
};

export const TITLE_ACTION_GROUPS = ['workflow', 'documents', 'data', 'administration', 'danger'];

export function normalizeTitleAction(entry, locale = 'fr') {
    const definition = TITLE_ACTION_DEFINITIONS[entry.kind];
    if (!definition) return { ...entry, icon: entry.icon || 'mdi-lightning-bolt-outline', color: entry.color || 'primary' };
    const label = definition.labels?.[String(locale).toLowerCase().startsWith('fr') ? 0 : 1];
    return {
        ...entry,
        icon: definition.icon,
        color: definition.color,
        group: entry.group || definition.group,
        label: label || entry.label,
        priority: entry.priority ?? (entry.main ? 110 : definition.priority),
        secondary: entry.secondary || definition.secondary,
    };
}
